<template>
    <div>
        <div class="card">
            <div class="card-header border-bottom d-flex justify-content-between pr-3 align-items-center">
                <span class="header-title mb-0">{{ __("Guests") }}</span>
                <button class="btn btn-primary" @click="openUploadMode">{{ __('Import Data') }}</button>
            </div>
            <div class="card-body">
                <div class="d-flex mb-2 justify-content-between align-items-center flex-wrap">
                    <date-range-picker 
                        ref="picker1"
                        :timePicker="false"
                        :timePicker24Hour="false"
                        :showWeekNumbers="false" 
                        :showDropdowns="true"
                        :ranges="$global.isMobile ? false : getDefaultDateRanges()"
                        v-model="filters.dateRange"
                        :linkedCalendars="true"
                        :autoApply="true">
                    </date-range-picker>
                    <div class="d-flex flex-column flex-md-row mt-2 mt-md-0">
                        <a href="#" class="blue-link mr-md-2 mb-1 mb-md-0" @click.prevent="unsubscribeForm">
                            <i class="far fa-stop-circle"></i> {{ __('Manage Unsubscribes') }}
                        </a>
                        <a href="#" class="blue-link" @click.prevent="showCalendar">
                            <i class="far fa-calendar"></i> {{ __('View Sending Calendar') }}
                        </a>
                    </div>
                </div>

                <table class="table table-hover table-responsive">
                    <thead>
                        <tr>
                            <th scope="col">{{ __('Reservation Number') }}</th>
                            <th scope="col">{{ __('First') }}</th>
                            <th scope="col">{{ __('Last') }}</th>
                            <th scope="col">{{ __('Email') }}</th>
                            <th scope="col">{{ __('Arrival') }}</th>
                            <th scope="col">{{ __('Departure') }}</th>
                            <th scope="col">{{ __('Replied/Sent') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="booking in bookings" :key="booking.guestId + '_' + booking.referenceNumber">
                            <td>{{ booking.referenceNumber }}</td>
                            <td>{{ booking.firstName }}</td>
                            <td>{{ booking.lastName }}</td>
                            <td>{{ booking.email }}</td>
                            <td>{{ booking.startDate | formatDate }}</td>
                            <td>{{ booking.endDate | formatDate }}</td>
                            <td>{{ booking.surveysResponded }} / {{ booking.surveysSent }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-center">
                    <button type="button" class="btn btn-secondary" v-if="page < pagingInfo.lastPage" @click="loadMore">{{ __('LOAD MORE') }}</button>
                    <p v-else class="readable-text">{{ __('There are no more booking to load') }}</p>
                </div>
            </div>
        </div>
        <div class="modal" id="export-modal" ref="upload_modal" v-if="activeModal != ''" tabindex="-1" role="dialog">
            <div class="modal-dialog" :class="{'gf full-width': activeModal == 'calendar'}" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <span v-if="activeModal == 'upload'">{{ __('Import Data') }}</span>
                            <span v-if="activeModal == 'calendar'">{{ __('Calendar') }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form v-if="activeModal == 'upload'" class="col-md-12">
                            <div class="form-group">
                                <p class="thin-title">{{ __('Here you can import data from your PMS.') }}</p>
                                <div class="text-right">
                                    <a href="/assets/survey-sample.csv" class="blue-link">
                                        <i class="fa fa-file-excel"></i> Download Sample
                                    </a>
                                </div>
                                <input style="padding:0;"class="mt-4 form-control" type="file" id="file" ref="file"
                                    v-on:change="handleFileUpload()" />
                            </div>

                            <button v-bind:disabled="file == ''" class="btn btn-primary mt-3" v-on:click="submitFile()">
                                Upload bookings
                            </button>
                        </form>
                        <surveys-calendar v-if="activeModal == 'calendar'" />
                        <manage-unsubscribes v-if="activeModal == 'unsubscribes'" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import SurveysService from "../../services/surveys-service";
import DateRangePicker from 'vue2-daterange-picker'
import SurveysCalendar from './SurveysCalendar.vue';
import ManageUnsubscribes from './ManageUnsubscribes.vue';
export default {
    components: {
        DateRangePicker,
        SurveysCalendar,
        ManageUnsubscribes
    },
    data() {
        
        return {
            activeModal: '',
            file: "",
            bookings: null,
            filters: {
                dateRange: {
                    startDate: moment().startOf('year').toDate(),
                    endDate: moment().toDate()
                },
            },
            pagingInfo: {},
            page: 1
        };
    },
    watch: {
        filters: {
            immediate: true,
            deep: true,
            handler: function (newVal, oldVal) {
                this.page = 1;
                this.getBookings();
            }
        }
    },
    mounted() {
        this.getBookings();
    },
    filters: {
        formatDate(date) {
            return moment(date).format('ll');
        }
    },
    methods: {
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
        },
        openUploadMode() {
            this.activeModal = 'upload';
            this.$nextTick(function() {
                $(this.$refs.upload_modal).modal('toggle');
                $(this.$refs.upload_modal).on('hide.bs.modal', function () {
                    this.activeModal = '';
                });
            })
        },
        loadMore() {
            this.page++;
            this.getBookings();
        },
        showCalendar() {
            this.activeModal = 'calendar';
            this.$nextTick(function() {
                $(this.$refs.upload_modal).modal('toggle');
                $(this.$refs.upload_modal).on('hide.bs.modal', function () {
                    this.activeModal = '';
                });
            })
        },
        unsubscribeForm() {
            this.activeModal = 'unsubscribes';
            this.$nextTick(function() {
                $(this.$refs.upload_modal).modal('toggle');
                $(this.$refs.upload_modal).on('hide.bs.modal', function () {
                    this.activeModal = '';
                });
            })
        },
        async getBookings() {
            const filters = {
                from: this.filters.dateRange.startDate,
                to: this.filters.dateRange.endDate
            };
            const data = await SurveysService.bookings.index(this.page, filters);
            if (this.page == 1) {
                this.bookings = [];
            }
            this.pagingInfo = {
                lastPage: data.lastPage,
                total: data.total
            };
            this.bookings = this.bookings.concat(data.data);
        },
        async submitFile() {
            let formData = new FormData();
            formData.append("bookings_csv", this.file);

            const data = await SurveysService.bookings.upload(formData);

            if (data.error) {
                swal({
                    title: "CSV not imported",
                    text: data.error,
                    type: "warning",
                    showCloseButton: true,
                    timer: 10000
                });
            } else {
                swal({
                    title: "CSV imported",
                    text: data.message,
                    type: "success",
                    showCloseButton: true,
                    timer: 10000
                });
            }
        }
    }
};
</script>
